import _toConsumableArray from "/home/runner/work/contribute/contribute/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/contribute/contribute/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { getAnchoredPosition } from '@primer/behaviors';
import { useProvidedRefOrCreate } from './useProvidedRefOrCreate';
import { useResizeObserver } from './useResizeObserver';
import useLayoutEffect from '../utils/useIsomorphicLayoutEffect';
/**
 * Calculates the top and left values for an absolutely-positioned floating element
 * to be anchored to some anchor element. Returns refs for the floating element
 * and the anchor element, along with the position.
 * @param settings Settings for calculating the anchored position.
 * @param dependencies Dependencies to determine when to re-calculate the position.
 * @returns An object of {top: number, left: number} to absolutely-position the
 * floating element.
 */

export function useAnchoredPosition(settings) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var floatingElementRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.floatingElementRef);
  var anchorElementRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.anchorElementRef);

  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      position = _React$useState2[0],
      setPosition = _React$useState2[1];

  var updatePosition = React.useCallback(function () {
    if (floatingElementRef.current instanceof Element && anchorElementRef.current instanceof Element) {
      setPosition(getAnchoredPosition(floatingElementRef.current, anchorElementRef.current, settings));
    } else {
      setPosition(undefined);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [floatingElementRef, anchorElementRef].concat(_toConsumableArray(dependencies)));
  useLayoutEffect(updatePosition, [updatePosition]);
  useResizeObserver(updatePosition);
  return {
    floatingElementRef: floatingElementRef,
    anchorElementRef: anchorElementRef,
    position: position
  };
}